import axios from '../../utils/axios';

export const getJobsAsync = async () => {
    const response = await axios.get('/jobs');
    return response.data;
}

export const createNewJob = async (jobData) => {
    const response = await axios.post('/jobs', jobData);
    return response.data;
}

export const updateJob = async ({id, jobData}) => {
    const response = await axios.put(`/jobs/${id}`, jobData);
    return response.data;
}

export const deleteJob = async (jobId) => {
    const response = await axios.delete(`/jobs/${jobId}`);
    return response.data;
}